
var LinesShader = {
    uniforms: {
        "tDiffuse": { value: null },
        "mixFactor": { value: 0.1 },
        "angle": { value: 90 },
        "eachLine": { value: 4.0 },
        "resolution": { value: null },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        uniform float mixFactor;
        uniform float angle;
        uniform float eachLine;
        uniform vec2 resolution;
        varying vec2 vUv;

        void main() {
            vec4 texel = texture2D(tDiffuse, vUv);
            vec2 st = gl_FragCoord.xy / resolution;
            if (texel.a <= 0.0) {
                gl_FragColor = texel;
                return;
            }
            
            float is_draw = mod(gl_FragCoord.y - gl_FragCoord.x*cos(radians(angle)), eachLine);
            float pct = (1.0) - float(int(is_draw));
    
            vec3 color_mix = texel.rgb * (vec3(pct) + vec3(mixFactor));
            gl_FragColor = vec4(color_mix, texel.a);
        }
    `,

};

export { LinesShader };
